import { Button } from '@fabric-app/ui/components/Button';
import { Flex } from '@fabric-app/ui/components/Flex';
import { mediaHover } from '@fabric-app/ui/constants/styled-utils';
import { cssVar } from '@fabric-app/ui/theme/variables';
import { styled } from 'styled-components';

const Form = styled.form`
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 400px;
  width: 100%;
  gap: 40px;
  & > * {
    width: 100%;
  }
`;

const Title = styled.h1`
  font-size: 2.125rem;
  font-weight: 700;
  color: ${cssVar['color-text-primary']};
  text-align: left;
`;

const Footer = styled.div`
  font-weight: 600;
  font-size: 15px;
  line-height: 18px;
  text-align: center;
  align-items: center;

  display: flex;
  flex-direction: column;
  margin-top: 20px;
  gap: 20px;
  color: rgba(${cssVar['color-text-primary-rgb']}, 0.5);
  max-width: 400px;
  width: 100%;

  a {
    color: ${cssVar['color-app-primary-text']};
    text-decoration: none;

    &:not(:disabled) {
      cursor: pointer;
    }
  }
`;

const Text = styled.div`
  font-size: 15px;
  font-weight: 600;
  color: ${cssVar['color-text-quinary']};
  text-align: center;
  line-height: 18px;
`;

const OauthButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  color: ${cssVar['color-text-primary']};
  border-radius: 13px;
  height: 50px;
  font-size: 15px;
  font-weight: 500;
  gap: 1rem;
  padding: 0 1rem;
  svg {
    width: 1.25rem;
    height: 1.25rem;
  }
  svg[data-icon='apple_old'] {
    transform: translateY(-2px);
  }
  &:disabled {
    opacity: 0.5 !important;
    background: transparent;
    color: ${cssVar['color-text-primary']};
  }
  border: 2px solid rgba(${cssVar['color-bg-primary-reverse-rgb']}, 0.1);
  color: ${cssVar['color-text-primary']};
  background: ${cssVar['color-bg-primary']};
  ${mediaHover} {
    &:hover {
      border: 2px solid rgba(${cssVar['color-bg-primary-reverse-rgb']}, 0.15);
    }
  }
`;

const framerItemVariant = {
  hidden: { opacity: 0 },
  show: { opacity: 1 },
};

/**
 * if you want to wrap input with error message
 * <AuthForm.InputContainer>
 *  <AuthTextInput />
 *  {condition && <AuthForm.ErrorMessage />}
 * </AuthForm.InputContainer>
 */
const InputContainer = styled(Flex).attrs({
  gap: 12,
  alignItems: 'center',
  direction: 'column',
})`
  width: 100%;
`;

const ErrorMessage = styled.div`
  color: #ff0000;
  font-size: 15px;
  font-weight: 600;
  transition: 0.2s all;
`;

const AuthButton = styled(Button)`
  height: 50px;
  background: ${cssVar['color-bg-primary-reverse']};
  color: ${cssVar['color-text-primary-reverse']};
  font-size: 1rem !important;
  border-radius: 13px;
  font-weight: 600;
  width: 100%;
  border: none !important;
  transition: none;
`;

export const AuthForm = {
  Form,
  Title,
  Footer,
  Text,
  OauthButton,
  Button: AuthButton,
  framerItemVariant,
  InputContainer,
  ErrorMessage,
};
